import {Component, OnInit} from '@angular/core';
import {EventBusService} from '../../services/support/event-bus.service';
import {NgIf} from '@angular/common';

@Component({
    selector: 'fullScreenLoader',
    templateUrl: 'fullScreenLoader.component.html',
    styleUrls: ['fullScreenLoader.component.scss'],
    standalone: true,
    imports: [
        NgIf
    ]
})
export class FullScreenLoader implements OnInit {

    message: string;
    visible: boolean = false;

    constructor(private eventBusService: EventBusService) {
    }

    ngOnInit() {
        this.eventBusService.getLoadingEvents().subscribe({
            next: (loadingEvent: any) => {
                if (loadingEvent) {
                    this.visible = loadingEvent.loading;

                    if (loadingEvent.message) {
                        this.message = loadingEvent.message;
                    } else {
                        this.message = '';
                    }
                }
            }
        });
    }
}
